import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setInitMessage } from '../actions/CommonAction';
import './MessageArea.css';
import { ERROR } from '../../common/message';

/**
 * メッセージ領域コンポーネント
 */
class MessageArea extends Component {
  componentDidMount() {
    const { setInitMessageAct } = this.props;
    setInitMessageAct();
  }

  componentDidUpdate(preProps) {
    const { systemLodingFLg, setInitMessageAct } = this.props;
    if (preProps.systemLodingFLg !== systemLodingFLg) {
      // 現在表示されているメッセージを初期化するため、
      // API呼び出しの際に「systemLodingFLg」をTRUEに更新するため、同時に「setInitMessage」を呼び出す
      if (systemLodingFLg) {
        setInitMessageAct();
      }
    }
  }

  render() {
    const {
      infoMessages,
      warnMessages,
      errorMessages,
      authErrorFlg,
      multiLoginFlg,
    } = this.props;
    let c = '';
    let m = [];
    if (errorMessages && errorMessages.length !== 0) {
      c = 'msg-error';
      m = errorMessages;
    } else if (multiLoginFlg) {
      c = 'msg-error';
      m = ERROR.E00015;
    } else if (authErrorFlg) {
      c = 'msg-error';
      m = ERROR.E00014;
    } else if (warnMessages && warnMessages.length !== 0) {
      c = 'msg-warn';
      m = warnMessages;
    } else if (infoMessages) {
      c = 'msg-info';
      m = infoMessages;
    }
    return (
      <div className={c}><span>{m}</span></div>
    );
  }
}

export default connect(
  (state) => ({
    infoMessages: state.common.infoMessages,
    warnMessages: state.common.warnMessages,
    errorMessages: state.common.errorMessages,
    authErrorFlg: state.common.authErrorFlg,
    multiLoginFlg: state.common.multiLoginFlg,
    systemLodingFLg: state.common.systemLodingFLg,
  }),
  (dispatch) => ({
    setInitMessageAct: () => dispatch(setInitMessage()),
  }),
)(MessageArea);
